import get from 'lodash/get'

export default (siblingPath, startFieldName, endFieldName, siblingCompareCallback) => function (value, parentVm) {
  let siblings = get(this, siblingPath)
  let startValue = parentVm[startFieldName]
  let endValue = parentVm[endFieldName]

  let similarSiblings = siblings.filter(sibling => {
    if (sibling === parentVm) {
      return false
    }

    return siblingCompareCallback(parentVm, sibling)
  })

  let siblingRanges = similarSiblings.map(sibling => {
    return {
      startValue: sibling[startFieldName],
      endValue: sibling[endFieldName]
    }
  })

  let overlap = siblingRanges.reduce((result, siblingRange) => {
    let isBefore = siblingRange.startValue < startValue && siblingRange.endValue < startValue
    let isAfter = endValue < siblingRange.startValue && endValue < siblingRange.endValue

    return result || !(isBefore || isAfter)
  }, false)

  return !overlap
}



// WEBPACK FOOTER //
// ./src/validators/noOverlapInSimilarSiblings.js